import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';

export default function PMLayout() {
  return (
    <div style={layoutStyles.page}>
      <Sidebar />
      <div style={layoutStyles.content}>
        <Outlet />
      </div>
    </div>
  );
}

const layoutStyles = {
  page: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '2rem',
    background: '#F5F7FA',
    fontFamily: 'Arial, sans-serif',
  },
};